import React, { Dispatch, SetStateAction } from 'react';
import { Modal, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import FormActions from '../../../components/FormActions';
import { WindowInformation } from '../../../services/window-information';
import { parseTextWithBold } from '../DeacCommons';

interface ModalProps {
    isModalVisible: boolean;
    setIsModalVisible: Dispatch<SetStateAction<boolean>>;
    selectedVacancies: Vacancy[];
    onConfirm: () => void;
}

export default function CloseApplicationsModal({ selectedVacancies, isModalVisible, setIsModalVisible, onConfirm }: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const closeModal = () => {
        setIsModalVisible(false);
    };

    return (
        <Modal
            transparent
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => closeModal()}
        >
            <View style={styles.container}>
                <View style={styles.formContainer(windowInfo.isMobile)}>
                    <MyAppText style={styles.header}>{translate('finalizeApplicationsAcceptance')}</MyAppText>

                    <View style={{ flexDirection: 'column', rowGap: 4, alignItems: 'center' }}>
                        <MyAppText style={styles.subheader}>{parseTextWithBold(translate('cancelApplicationMessage', { quantity: selectedVacancies.length, status: translate('opened') }))}</MyAppText>
                    </View>
                    <FormActions
                        viewStyle={{ flex: 1, justifyContent: 'space-around' }}
                        buttonStyle={{ paddingHorizontal: 16, paddingVertical: 9, }}
                        buttonContentContainerStyle={{ flex: 1 }}
                        cancelText='goBack'
                        confirmText='finalize'
                        onSubmit={onConfirm}
                        onClose={closeModal}
                        disabled={false}
                    />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1,
        paddingHorizontal: 16,
    },
    formContainer: (isMobile: boolean) => ({
        width: isMobile ? '95%' : 450,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        paddingHorizontal: 16,
        paddingVertical: 24,
        rowGap: 32,
    }),
    header: {
        fontSize: 18,
        fontWeight: '700',
        flexWrap: 'wrap',
        color: theme.colors.modal.header,
    },
    subheader: {
        fontSize: 16,
        fontWeight: '400',
        flexWrap: 'wrap',
        color: theme.colors.modal.subheader,
    },
    subheaderName: {
        fontSize: 16,
        fontWeight: '700',
        flexWrap: 'wrap',
        color: theme.colors.modal.subheader,
    },
}));
